import styled from '@emotion/styled'

export const Main = styled.div((props) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: `${props.fitContent?1:''}`,
  height: 'auto',

  '&.highlight': {
    borderRadius: '5px', 
    boxShadow: '0px 0px 5px 1px #FBBF66'
  },

  '.header':{
    display:'flxe',
    alignItems:'center',
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    background: '#EAEFF5',
    padding: 12,
    // marginTop: 20,
    fontFamily: 'IBM Plex Sans Thai',
    fontSize: '1.25rem',
    fontWeight: 'bold',
    minHeight:'3rem',
    justifyContent:'space-between',

    '.accessories':{
      display:'flex'
    }
  },

  '.content':{
    fontSize: '1rem',
    padding:12,
    background:'#fff',
    borderBottomLeftRadius:5,
    borderBottomRightRadius:5
  },

  '.hideHeader':{
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
  }

}))
